import React, { useMemo } from "react";
import {
    Button,
    Snackbar,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions
} from "@material-ui/core";
import MuiAlert from "@material-ui/lab/Alert";
import { useDispatch } from "react-redux";
import {
    MxAlertaActions,
    TypesMxAlerta
} from "../store/ducks/components/mxalerta/mxalerta";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { useTypedSelector } from "../hooks";

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const MxAlerta = props => {
    const dispatch = useDispatch();
    const stateMxAlerta = useTypedSelector(state => state.mxalertareducer);

    const closeSnackBar = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }

        dispatch({ type: TypesMxAlerta.CLOSEALERTA });
    };
    const ButtonAtualizar = useMemo(() => {
        return stateMxAlerta.ShowButtonAtualizar ? (
            <Button
                variant="contained"
                color="primary"
                size="small"
                onClick={props.onClick}
            >
                ATUALIZAR
            </Button>
        ) : (
            false
        );
    }, [stateMxAlerta.ShowButtonAtualizar, props.onClick]);

    switch (stateMxAlerta.AlertTipo) {
        case "OPENALERTA":
            return (
                <AlertSnackbar
                    open={stateMxAlerta.Open}
                    onClose={closeSnackBar}
                    severity={stateMxAlerta.Tipo}
                    text={stateMxAlerta.Mensagem}
                    action={ButtonAtualizar}
                    autoHideDuration={4000}
                />
            );

        case "OPENALERTAUPDATE":
            return (
                <AlertSnackbar
                    open={stateMxAlerta.Open}
                    onClose={() => {}}
                    severity={stateMxAlerta.Tipo}
                    text={stateMxAlerta.Mensagem}
                    action={ButtonAtualizar}
                    autoHideDuration={50000}
                />
            );

        case "OPENCONFIRM":
            return (
                <DialogConfirmRefuse
                    open={stateMxAlerta.Open}
                    onCancel={() => dispatch(MxAlertaActions.ExecutarClose())}
                    onConfirm={() =>
                        stateMxAlerta.SimClick(stateMxAlerta.Parametro)
                    }
                    onRefuse={() =>
                        stateMxAlerta.NaoClick(stateMxAlerta.Parametro)
                    }
                    title={stateMxAlerta.Titulo}
                    text={stateMxAlerta.Texto}
                    showCancel={stateMxAlerta.CancelButton}
                />
            );

        case "OPENERRO":
            return (
                <DialogError
                    open={stateMxAlerta.Open}
                    title={stateMxAlerta.Titulo}
                    text={stateMxAlerta.Texto}
                    onClick={() =>
                        stateMxAlerta.OkClick(stateMxAlerta.Parametro)
                    }
                />
            );
        case "OPENOKCONFIRM":
            return (
                <DialogAlert
                    onClick={() => stateMxAlerta.SimClick()}
                    text={stateMxAlerta.Texto}
                    title={stateMxAlerta.Titulo}
                    open={stateMxAlerta.Open}
                    confirmText={stateMxAlerta.ConfirmText}
                />
            );
        case "OPENONLYCONFIRM":
            return (
                <DialogConfirm
                    text={stateMxAlerta.Texto}
                    title={stateMxAlerta.Titulo}
                    open={stateMxAlerta.Open}
                    onCancel={() => stateMxAlerta.NaoClick()}
                    onConfirm={() => stateMxAlerta.SimClick()}
                    cancelText={stateMxAlerta.CancelText}
                    confirmText={stateMxAlerta.ConfirmText}
                />
            );
        default:
            return <></>;
    }
};

export default MxAlerta;

function AlertSnackbar({
    open,
    onClose,
    severity,
    text,
    action,
    autoHideDuration
}) {
    return (
        <Snackbar
            open={open}
            autoHideDuration={autoHideDuration}
            onClose={onClose}
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
            <Alert onClose={onClose} severity={severity} action={action}>
                {text}
            </Alert>
        </Snackbar>
    );
}

function DialogConfirmRefuse({
    open,
    title,
    text,
    onConfirm,
    onCancel,
    onRefuse,
    showCancel
}) {
    return (
        <Dialog
            aria-labelledby="simple-dialog-title"
            open={open}
            disableBackdropClick
            disableEscapeKeyDown
        >
            <DialogTitle id="simple-dialog-title" style={{ color: "red" }}>
                {title}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {text}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                {showCancel ? (
                    <Button
                        onClick={() => {
                            onCancel();
                        }}
                        color="default"
                        style={{
                            marginRight: "auto",
                            marginLeft: "8px"
                        }}
                    >
                        Cancelar
                    </Button>
                ) : null}
                <Button onClick={() => onRefuse()} color="secondary" autoFocus>
                    Não
                </Button>
                <Button onClick={() => onConfirm()} color="primary">
                    Sim
                </Button>
            </DialogActions>
        </Dialog>
    );
}

function DialogError({ open, title, text, onClick }) {
    return (
        <Dialog
            aria-labelledby="simple-dialog-title"
            open={open}
            disableBackdropClick
            disableEscapeKeyDown
        >
            <DialogTitle id="simple-dialog-title" style={{ color: "blue" }}>
                <ErrorOutlineIcon /> {title}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {text}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={() => onClick()}
                    color="primary"
                    style={{ marginInline: "auto" }}
                    autoFocus
                >
                    OK
                </Button>
            </DialogActions>
        </Dialog>
    );
}

function DialogConfirm({
    onConfirm,
    onCancel,
    title,
    text,
    open,
    confirmText = "Confirmar",
    cancelText = "Cancelar"
}) {
    return (
        <Dialog
            aria-labelledby="simple-dialog-title"
            open={open}
            disableBackdropClick
            disableEscapeKeyDown
        >
            <DialogTitle id="simple-dialog-title" style={{ color: "blue" }}>
                {title}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {text}
                </DialogContentText>
            </DialogContent>
            <DialogActions
                style={{
                    justifyContent: "space-around"
                }}
            >
                <Button onClick={() => onConfirm()} color="primary" autoFocus>
                    {confirmText}
                </Button>
                <Button onClick={() => onCancel()} color="inherit" autoFocus>
                    {cancelText}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

function DialogAlert({ open, title, text, onClick, confirmText = "OK" }) {
    return (
        <Dialog
            aria-labelledby="simple-dialog-title"
            open={open}
            disableBackdropClick
            disableEscapeKeyDown
        >
            <DialogTitle id="simple-dialog-title" style={{ color: "blue" }}>
                {title}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {text}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={() => onClick()}
                    color="primary"
                    style={{ marginInline: "auto" }}
                    autoFocus
                >
                    {confirmText}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
